<div class="d-flex w-100">
  <div class="col-3 d-flex justify-content-start">
    <button (click)="goBack()" class="btn border-0 p-0 m-0 col-3">
      <i *ngIf="!language.isArabic" class="bi bi-arrow-left main-color tw-text-2xl"></i>
      <i *ngIf="language.isArabic" class="bi bi-arrow-right main-color tw-text-2xl"></i>
    </button>
  </div>
  <h4 class="col-6 text-center header-item me-2 main-color tw-text-xl tw-font-medium">{{title | translate}}</h4>
</div>
